import type { NewsArticle } from "@/types";
import { formatDate } from "@/utils/format";
import { Link } from "react-router-dom";

interface NewsCardProps {
  article: NewsArticle;
  variant?: "row" | "grid";
}

export default function NewsCard({ article, variant = "row" }: NewsCardProps) {
  if (variant === "grid") {
    return (
      <Link
        to={`/news/${article.id}`}
        className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-secondary-300 transition-all duration-300"
      >
        <div className="relative w-full aspect-[16/10] overflow-hidden">
          <img
            src={article.thumbnail}
            alt={`${article.title} 配图`}
            title={`${article.title} - 佐山爱明星动态`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="p-4 md:p-5 flex flex-col gap-3">
          <div className="flex items-center gap-2 flex-wrap">
            {article.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 rounded-md text-[11px] bg-secondary-100 text-secondary-900"
              >
                {tag}
              </span>
            ))}
          </div>
          <h3 className="font-heading font-semibold text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
            {article.summary}
          </p>
          <span className="text-xs text-foreground-400 mt-auto pt-1">
            {formatDate(article.date)}
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${article.id}`}
      className="group flex gap-4 p-3 md:p-4 rounded-lg bg-background-100 border border-background-200/70 hover:border-secondary-300 transition-all duration-300"
    >
      <div className="relative w-28 h-20 md:w-40 md:h-24 flex-shrink-0 rounded-md overflow-hidden">
        <img
          src={article.thumbnail}
          alt={`${article.title} 配图`}
          title={`${article.title} - 佐山爱明星动态`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col gap-1.5 min-w-0 flex-1">
        <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
          {article.title}
        </h3>
        <p className="hidden sm:block text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {article.summary}
        </p>
        <span className="text-xs text-foreground-400 mt-auto flex items-center gap-1.5">
          <i className="ri-calendar-line" />
          {formatDate(article.date)}
        </span>
      </div>
    </Link>
  );
}